import React, { forwardRef, useEffect, useRef } from 'react';
import '../css/MainContent.css';
import roomrosterrooms from '../roomrosterrooms.jpg';
import roomrostercalllist from '../roomrostercalllist.png';
import roomrosterworkorders from '../roomrosterworkorders.png';

const MainContent = forwardRef((props, ref) => {
  const section1Ref = useRef();
  const section2Ref = useRef();
  const section3Ref = useRef();

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    if (section1Ref.current) observer.observe(section1Ref.current);
    if (section2Ref.current) observer.observe(section2Ref.current);
    if (section3Ref.current) observer.observe(section3Ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="mainContent" ref={ref}>
        <div>
            <h2>Custom Solutions for Your Property Management Needs</h2>
            <p>With over 10 years of experience in the property management industry, we have the knowledge and expertise to help you with your property management needs.</p>
        </div>
        <div className='sectionOne' ref={section1Ref}>
            <img src={roomrostercalllist} alt="Lead management system showing call list interface with contact tracking" className='roomRosterPic' />
            <p>track and manage leads from first touch to check in with our integrated Lead Management System</p>
        </div>
        <div className='sectionTwo' ref={section2Ref}>
            <p>manage your properties with our integrated Property Management System</p>
            <img src={roomrosterrooms} alt="Property management dashboard displaying room occupancy and status" className='roomRosterPic' />
        </div>
        <div className='sectionOne' ref={section3Ref}>
            <img src={roomrosterworkorders} alt="Work order management interface with task tracking and status updates" className='roomRosterPic' />
            <div>
                <p>track and manage work orders with our integrated Work Order Management System</p>
            </div>
        </div>
    </div>
  );
});

export default MainContent;
